<template>
  <div class="modal-dialog">
    <div class="modal-content success-pop-up">
      <div class="modal-body">
        <button type="button" class="close resource-close" @click="updateResourceData()" data-dismiss="modal">
          &times;
        </button>
        <p class="create-an-announcement">{{ title }}</p>
        <img src="static/img/resource-module-green-check.png" alt="" class="green-pop-check" />
        <p class="success-message">{{ successMsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessPopup",
  props: ["title", "successMsg"],
  methods: {
    updateResourceData() {
      if (!this.title.includes("Edit")) {
        this.$root.$emit("resource_uploaded", true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.success-pop-up {
  width: 350px;
  height: 300px;
  margin: 0 0 3.1px;
  // padding: 114px 8px 12.3px 6px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
button.resource-close {
  position: relative;
  left: 7px;
  bottom: 10px;
  font-size: 18px;
}
.green-pop-check {
  width: 78px;
  height: 78px;
  margin: 46px 0px 3.9px 122px;
  object-fit: contain;
}
.success-message {
  height: 47px;
  // margin: 0.9px 0px 0px 18px;
  text-align: center;
  font-size: 16px;
  line-height: 2;
  color: #666669;
  font-family: "RobotoRegular";
}
.create-an-announcement {
  // width: 226px;
  height: 20px;
  // margin: 39px 37px 2.5px 259px;
  font-family: "RobotoRegular";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
</style>
